export default __webpack_public_path__ + "static/media/CityLights02.8ac5562c.jpg";